import { axiosPost, axiosPut } from 'shared/api/axios'
import { AxiosError, AxiosResponse } from 'axios'
import { apiUrls } from 'consts'
import displayGenError from 'shared/utils/displayGenError'
import setFormValidationError from 'shared/utils/setFormValidationError'

interface submitFormProps {
  data: any
  setShowOverlay: Function
  id: string | undefined
  setError: Function
  extraData?: any
}

const submitForm = async (props: submitFormProps) => {
  let response: any = false

  const formData = {
    ...props.data,
  }

  const catchFunc = (err: AxiosError) => {
    if (err.response!.status === 422) {
      setFormValidationError(err, props.setError, undefined, 'name')
    } else {
      displayGenError({ setShowOverlay: props.setShowOverlay })
    }
  }

  if (props.id === undefined) {

      const filterValueIds: Array<number> = props.extraData.filterValues.map((f) => f.filter_value_id)
      const sectionIds: Array<number> = props.extraData.sections.map((s) => s.section_id)
      
      const response = await axiosPost(apiUrls.permissions, formData, catchFunc);

      if (response?.status === 201) {
        const permissionId = response.data.id;

        const promises: Promise<AxiosResponse<any>>[] = [];

        const filterPromise = axiosPost(
          apiUrls.filterValuesToPermissions + '/' + apiUrls.actionBulkCreate,
          {
            permission_id: permissionId,
            filter_value_ids: filterValueIds,
          },
          catchFunc
        );
        promises.push(filterPromise);

        sectionIds.forEach((sectionId) => {
          const sectionPromise = axiosPost(
            apiUrls.permissionsToSections,
            {
              section_id: sectionId,
              permission_id: permissionId,
            },
            catchFunc
          );
          promises.push(sectionPromise);
        });
        await Promise.all(promises);
      }
      return response;
    } else {
      response = await axiosPut(apiUrls.permissions + '/' + props.id, formData, catchFunc)
    }
  return response
}

export default submitForm
